<template>
    <div class="AdminLayout">
        <AdminSidebar ref="adminSidebar"/>

        <div class="main">
            <div class="header">
                <div>
                    <div class="menu" @click="toggleMenu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <Dropdown v-if="user">
                    <template #trigger>
                        <CompanyLogo nameDisplay="user"/>
                    </template>
                    <template #menu>
                        <button class="danger" @click="handleLogout">Log out</button>
                    </template>
                </Dropdown>
            </div>

            <div class="content">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import CompanyLogo from '@/components/CompanyLogo';
import Dropdown from '@/components/Dropdown';
import AdminSidebar from './components/AdminSidebar';

export default {
    name: 'AdminLayout',

    components: { AdminSidebar, CompanyLogo, Dropdown },

    computed: {
        ...mapState('auth', ['user']),
    },

    methods: {
        toggleMenu() {
            this.$refs.adminSidebar.toggle();
        },

        handleLogout() {
            this.$store.dispatch('auth/logout', { redirect: true });
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.AdminLayout {
    @extend %dashboard-layout;
}
</style>
